/* eslint-disable react/prop-types */
import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Tooltip from 'components/tooltip'
import useBreakpointWidth from 'common/hooks/useBreakpointWidth'

import styles from './RatesTableTooltip.module.scss'

const RatesTableTooltip = (props) => {
  const isNotMobile = !useBreakpointWidth('mobile')
  const {
    loadingClassName,
    analyticsOptions = {},
    placement = 'top',
    children,
    triggerType: triggerTypeProp,
    contentClassName,
    containerClassName,
    triggerClassName,
    ...restProps
  } = props
  const triggerType = triggerTypeProp || (isNotMobile ? 'hover' : 'click')

  return (
    <Tooltip
      triggerContent={
        <i
          className={cx(
            `cred-icon icon-help-outline`,
            styles.icon14,
            loadingClassName || triggerClassName,
          )}
        />
      }
      placement={placement}
      contentClassName={cx(styles.contentStyles, contentClassName)}
      containerClassName={cx(styles.containerStyles, containerClassName)}
      arrowClassName={styles.arrowClassName}
      analyticsOptions={analyticsOptions}
      triggerType={triggerType}
      {...restProps}
    >
      {children}
    </Tooltip>
  )
}

RatesTableTooltip.propTypes = {
  loadingClassName: PropTypes.string,
  analyticsOptions: PropTypes.object,
  placement: PropTypes.string,
  children: PropTypes.node.isRequired,
  triggerType: PropTypes.string,
}

export default RatesTableTooltip
